(() => {
  'use strict';
  const money = (value, currency) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(value / 100);
  function init(root) {
    if (root.dataset.duoReady) return;
    root.dataset.duoReady = 'true';
    const form = root.querySelector('[data-duo-form]');
    const selects = [...root.querySelectorAll('[data-duo-select]')];
    const button = root.querySelector('[data-duo-submit]');
    const status = root.querySelector('[data-duo-status]');
    const reduction = Number(root.dataset.discount);
    const currency = root.dataset.currency;
    let busy = false;
    let cartCheckRequired = false;
    const getSelection = () => selects.map(select => select.selectedOptions[0]);
    function evaluate() {
      const options = getSelection();
      const amounts = options.map(option => Number(option?.dataset.price));
      const validPrice = currency === 'EUR' && reduction > 0 && amounts.length === 2 && amounts.every(price => Number.isFinite(price) && price > reduction);
      const grouped = new Map();
      options.forEach(option => {
        if (!option) return;
        const existing = grouped.get(option.value);
        grouped.set(option.value, { id: option.value, quantity: (existing?.quantity || 0) + 1, option });
      });
      let error = validPrice ? '' : 'Cette offre n’est pas disponible pour cette sélection.';
      grouped.forEach(({ quantity, option }) => {
        if (option.dataset.available !== 'true') error = 'Ces coloris sont actuellement indisponibles. Vous pouvez modifier votre sélection.';
        const inventory = option.dataset.inventory;
        if (option.dataset.inventoryManaged === 'true' && inventory !== '' && Number(inventory) < quantity) error = 'Ce coloris n’est pas disponible dans la quantité choisie. Choisissez une autre combinaison.';
        const min = Number(option.dataset.min || 1);
        const step = Number(option.dataset.step || 1);
        const max = option.dataset.max ? Number(option.dataset.max) : Infinity;
        if (quantity < min || quantity > max || (quantity - min) % step !== 0) error = 'Cette combinaison ne respecte pas les quantités disponibles. Choisissez une autre combinaison.';
      });
      return { options, amounts, validPrice, grouped, error };
    }
    function update() {
      const selection = evaluate();
      selection.options.forEach((option, index) => {
        const image = root.querySelector(`[data-duo-image="${index}"]`);
        if (option && image) {
          image.src = option.dataset.image;
          image.alt = `AquaPulse One — ${option.dataset.name}`;
        }
      });
      if (selection.validPrice) {
        const separate = selection.amounts.reduce((sum, value) => sum + value, 0);
        root.querySelector('[data-duo-total]').textContent = money(separate - reduction, currency);
        root.querySelector('[data-duo-separate]').textContent = money(separate, currency);
        root.querySelector('[data-duo-saving]').textContent = `${money(reduction, currency)} d’économie sur le duo`;
      } else {
        root.querySelector('[data-duo-total]').textContent = 'Non disponible';
        root.querySelector('[data-duo-separate]').textContent = '—';
        root.querySelector('[data-duo-saving]').textContent = '';
      }
      button.disabled = busy || cartCheckRequired || Boolean(selection.error);
      selects.forEach(select => { select.disabled = busy || cartCheckRequired; });
      button.textContent = busy ? 'Ajout du duo…' : cartCheckRequired ? 'Vérifiez d’abord votre panier' : selection.error ? 'Pack actuellement indisponible' : 'Ajouter mon Pack Duo au panier';
      status.textContent = selection.error || 'Vos deux appareils sont disponibles. La remise est automatique au panier.';
      return selection;
    }
    selects.forEach(select => select.addEventListener('change', update));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || cartCheckRequired) return;
      const selection = update();
      if (selection.error) { status.focus(); return; }
      const items = [...selection.grouped.values()].map(({ id, quantity }) => ({ id, quantity }));
      busy = true;
      update();
      form.setAttribute('aria-busy', 'true');
      try {
        const endpoint = new URL(form.action, window.location.origin);
        endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
        const response = await fetch(endpoint.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'L’ajout du duo n’a pas pu être confirmé.');
        window.location.assign(root.dataset.cartUrl || '/cart');
      } catch (error) {
        busy = false;
        cartCheckRequired = true;
        form.removeAttribute('aria-busy');
        update();
        status.textContent = `${error.message || 'L’ajout du duo n’a pas pu être confirmé.'} Un appareil a peut-être été ajouté. Vérifiez votre panier avant une nouvelle tentative.`;
        root.querySelector('[data-duo-cart-check]').hidden = false;
      }
    });
    update();
  }
  function openLinkedBuilder() {
    const target = document.getElementById(window.location.hash.slice(1));
    const builder = target?.matches('[data-duo-builder]')
      ? target
      : target?.id === 'pack-duo' ? target.querySelector('[data-duo-builder]') : null;
    if (builder) builder.open = true;
  }
  function initialize(scope) { scope.querySelectorAll('[data-duo-builder]').forEach(init); openLinkedBuilder(); }
  initialize(document);
  window.addEventListener('hashchange', openLinkedBuilder);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-duo-open]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target) target.open = true;
  });
})();
